import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../services/global.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor( private global: GlobalService ) { 
    this.global.setDocumentTitle( 'Not Found' );
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/not-found/not-found.component.ts